var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleShoppingReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.google{fill:url(#google-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36069,
    stopColor: "#5998f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#3c85f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3369cb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "google",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M59.06055,45.2207h-18.12109c-.82861,0-1.5-.67188-1.5-1.5v-9.06055c0-5.82324,4.7373-10.56055,10.56055-10.56055s10.56055,4.7373,10.56055,10.56055v9.06055c0,.82812-.67139,1.5-1.5,1.5ZM42.43945,42.2207h15.12109v-7.56055c0-4.16895-3.3916-7.56055-7.56055-7.56055s-7.56055,3.3916-7.56055,7.56055v7.56055Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M70.2403,69.89813l-3.33984-28.05719c-.24109-2.02551-1.95874-3.55078-3.99854-3.55078h-25.80383c-2.03979,0-3.75739,1.52527-3.99847,3.55078l-3.3399,28.05719c-.28516,2.39569,1.58594,4.50275,3.99854,4.50275h32.48358c2.4126,0,4.28369-2.10706,3.99847-4.50275ZM58.68317,54.86139l-3.06073,3.31696.52649,4.48242c.11499.97931-.88635,1.70697-1.78217,1.29486l-4.10046-1.88586-4.1004,1.88586c-.89581.41211-1.89728-.31555-1.78223-1.29486l.52655-4.48242-3.06073-3.31696c-.6687-.72467-.28619-1.90192.68079-2.09515l4.42572-.8844,2.2088-3.93597c.4826-.85986,1.7204-.85986,2.203,0l2.2088,3.93597,4.42578.8844c.96698.19324,1.34949,1.37048.68079,2.09515Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleShoppingReviewsScraper);
export default __webpack_public_path__ + "static/media/google-shopping-reviews-scraper.d9f21c08ea9e44d331e81260e3c33840.svg";
export { ForwardRef as ReactComponent };